//For working on local
// export const API_BASE_URL = "http://192.168.29.23:3003";
// export const API_BASE_URL = "http://localhost:3003";
export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/ibs`;


//for pushing update on Git, I have to uncomment it
// export const API_BASE_URL = process.env.REACT_APP_BASEURL;
// export const IMAGE_URL = "https://portal.kairakitchen.com";
// export const VIEW_LEAD = "VIEW_LEAD";
// export const VIEW_PROPERTY = "VIEW_PROPERTY";
// export const EDIT_LEAD = "EDIT_LEAD";
// export const DELETE_LEAD = "DELETE_LEAD";
// export const VIEW_PRODUCT = "VIEW_PRODUCT";
// export const EDIT_PRODUCT = "EDIT_PRODUCT";
// export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const MODIFY_ALL = "MODIFY_ALL";
export const VIEW_ALL = "VIEW_ALL";
export const VIEW_CONTACT = "VIEW_CONTACT";
//Only Create Permission Added By Farhan Khan on 23-oct-2023
export const CREATE_ALL = "CREATE_ALL";

//FILE TYPES
export const PDF = "pdf";
export const DOC = "doc";
export const DOCX = "docx";
export const XLS = "xls";
export const XLSX = "xlsx";
export const CSV = "csv";
export const PNG = "png";
export const JPG = "jpg";
export const JPEG = "jpeg";

export const LIST_TAB_TITLE = {
    // "Home":"Garib Nawaz Trailors",
    "ContactList":"Students List",
    "ItemList":"Item List",
    "SupplierList":"Supplier List",
    "CourseList":"Course List",
    "ReportList":"Report List",
    "SupplierListEdit":"Supplier Edit",
    "ClientListEdit":"Client Edit",
    "TrasportEdit":"Transport Edit",
    "DriverList":"Driver List",
    "VechileList" : "Vechile List",
    "CountryList" : "Country List",
    "StateList" : "State List",
    "CityList" : "City List",
    "ChallanEdit" : "Challan Edit",
};

// Added By Farhan Khan on 13-Sep-2023
export const ChartColors = [
    "#6096B4",
    "#93BFCF",
    "#E6C229",
    "#FF7F00",
    "#D62728",
    "#93cfa9",
    "#c893cf",
    "#9a93cf",
    "#cacf93",
    "#29e66e",
    "#a429e6",
  ];
  export const Project_Stage_Status = [
    { label: "Class 10 - Social Studies" },
    { label: "Class 10 - English" },
    { label: "Class 10 - Maths" },
    { label: "Class 10 - Science" },
    { label: "Class 11 - Economics" },
    { label: "Class 11 - Accounts" },
    { label: "Class 12 - Applied Maths" },
    { label: "Class 12 - Accounts" },
    { label: "Class 9 - Maths" },
    { label: "Class 9 - Science" },
    { label: "CA Foundation - Accounts" },
    { label: "CA Inter - Economics" },
  ];

  export const LEAD_STATUS_VALUES = [
    {
      label: "Open - Not Contacted",
      sortorder: 1,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#008080", // Teal
    },
    {
      label: "Working - Contacted",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#4682B4", // Steel Blue
    },
    {
      label: "Call",
      sortorder: 3,
      is_converted: true,
      is_lost: false,
      backgroundColor: "#5F9EA0", // Cadet Blue
    },
    {
      label: "Showroom Visit",
      sortorder: 4,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#3CB371", // Medium Sea Green
    },
    {
      label: "Follow up",
      sortorder: 5,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#6B8E23", // Olive Drab
    },
    {
      label: "Project",
      sortorder: 6,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#CD853F", // Peru
    },
    {
      label: "On-Hold",
      sortorder: 7,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#BA55D3", // Peru
    },
    {
      label: "Archive",
      sortorder: 8,
      is_converted: false,
      is_lost: false,
      backgroundColor: "#CD853F", // Peru
    },
    // {
    //   label: "Quotation Rejected",
    //   sortorder: 7,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#CD5C5C", // Indian Red
    // },
    // {
    //   label: "Converted",
    //   sortorder: 8,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#BC8F8F", // Rosy Brown
    // },
    // {
    //   label: "Advance Received",
    //   sortorder: 9,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#DAA520", // Goldenrod
    // },
    // {
    //   label: "Production Transfered",
    //   sortorder: 10,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#FF57A6", // Slate Blue
    // },
    // {
    //   label: "Production Stage",
    //   sortorder: 11,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#9370DB", // Medium Purple
    // },
    // {
    //   label: "Material Ordered",
    //   sortorder: 12,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#BA55D3", // Medium Orchid
    // },
    // {
    //   label: "Production Phase One",
    //   sortorder: 13,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#E9967A", // Dark Salmon
    // },
    // {
    //   label: "Production Phase Two",
    //   sortorder: 14,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#F08080", // Light Coral
    // },
    // {
    //   label: "Production Phase Three",
    //   sortorder: 15,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#6495ED", // Sandy Brown
    // },
    // {
    //   label: "Production Phase Four",
    //   sortorder: 16,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#BDB76B", // Dark Khaki
    // },
    // {
    //   label: "Production Phase Five",
    //   sortorder: 17,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#778899", // Light Slate Gray
    // },
    // {
    //   label: "Dispatched",
    //   sortorder: 18,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#7B68EE", // Medium Slate Blue
    // },
    // {
    //   label: "Installation",
    //   sortorder: 19,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#6495ED", // Cornflower Blue
    // },
    // {
    //   label: "Payment",
    //   sortorder: 20,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#66CDAA", // Medium Aquamarine
    // },
    // {
    //   label: "Project Completed",
    //   sortorder: 21,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#20B2AA", // Light Sea Green
    // },
    // {
    //   label: "Reparing Ticket",
    //   sortorder: 22,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#DB7093", // Pale Violet Red
    // },
    // {
    //   label: "Reparing Ticket Complete",
    //   sortorder: 23,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#9F99AC", // Adjusted for your colors
    // },
    // {
    //   label: "Just Entry",
    //   sortorder: 24,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#48162C", // Adjusted for your colors
    // },
    // {
    //   label: "Archived",
    //   sortorder: 25,
    //   is_converted: false,
    //   is_lost: false,
    //   backgroundColor: "#FFC300", // Adjusted for your colors
    // },
  ];
  
  export const Product_CATEGORY_VALUES = [
    {
      label: "Software",
      sortorder: 1,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Hardware",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Fashion",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Retail",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Goods",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Furniture",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Stones",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Policy",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
    {
      label: "Others",
      sortorder: 2,
      is_converted: false,
      is_lost: false,
    },
  ];
  
  export const Repair_CATEGORY_VALUES = [
    {
      label: "Ticket Created",
      sortorder: 1,
      backgroundColor: "#DB7093", // Pale Violet Red
    },
  
    {
      label: "In Discussion",
      sortorder: 2,
      backgroundColor: "#DB7093", // Pale Violet Red
    },
    {
      label: "Not Working",
      sortorder: 3,
      backgroundColor: "#66CDAA", // Medium Aquamarine
    },
    {
      label: "Advance Recived",
      sortorder: 4,
      backgroundColor: "#20B2AA", // Light Sea Green
    },
    {
      label: "Work Started",
      sortorder: 5,
      backgroundColor: "#6495ED", // Cornflower Blue
    },
    {
      label: "Work Completed",
      sortorder: 6,
      backgroundColor: "#E9967A", // Dark Salmon
    },
  ];
    
  export const Project_Stage_Name = [
    {
      label: "Raw Material Purchase",
      sortorder: 1,
    },
    {
      label: "Material Finishing",
      sortorder: 2,
    },
    {
      label: "Stiching",
      sortorder: 3,
    },
    {
      label: "Order Dispatching",
      sortorder: 4,
    },
    {
      label: "Order Finishing",
      sortorder: 5,
    },
  
    {
      label: "Feeding and mixing",
      sortorder: 1,
    },
    {
      label: "Moulding and pressing",
      sortorder: 2,
    },
    {
      label: "Curing",
      sortorder: 3,
    },
    {
      label: "Polishing",
      sortorder: 4,
    },
    {
      label: "Quality Testing",
      sortorder: 5,
    },
    {
      label: "Tagging",
      sortorder: 6,
    },
  
    {
      label: "Dryer",
      sortorder: 1,
    },
    {
      label: "Pressing",
      sortorder: 2,
    },
    // {
    //     label: "A/c Room",
    //     sortorder: 3,
    // },
    {
      label: "Cutting",
      sortorder: 3,
    },
    {
      label: "Sanding",
      sortorder: 4,
    },
    {
      label: "Quality Check",
      sortorder: 5,
    },
    // {
    //     label: "BSR (Stock Ready)",
    //     sortorder: 7,
    // },
    {
      label: "Dispatch",
      sortorder: 6,
    },
  ];
  
